import type { ConditionField, ReportField } from "../../../../../../../../../../api/types/svTypes.ts";

export const isCustomIdUnique = (
  currentFieldGuid: string,
  customId: string,
  fields: ReportField[],
  conditions: ConditionField[]
) => {
  return [...fields, ...conditions].every(
    (item) =>
      item.config.guid === currentFieldGuid ||
      //Ensure that new customId doesn't equal to any customId or defaultId(guid) of other fields or conditions
      (item.config.customId !== customId && item.config.guid !== customId)
  );
};
